import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FrontendVersionSettings } from 'src/app/models/frontend-version-settings';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CheckForUpdateService {
  private http = inject(HttpClient);

  url = environment.ildatoArticoliDpi + 'api/version';
  apikey = environment.frontendVersionApiKey;
  
  getVersionFromServer(): Observable<FrontendVersionSettings> {
    return this.http.get<FrontendVersionSettings>(this.url+'/'+this.apikey);    
  }

}
